import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopNav } from './TopNav';
import { Sidebar } from './Sidebar';
export function AppLayout() {
  return <div className="flex flex-col h-screen bg-[var(--bg)] text-[var(--fg)]" data-id="element-40">
      <TopNav data-id="element-41" />
      <div className="flex flex-1 overflow-hidden" data-id="element-42">
        <Sidebar data-id="element-43" />
        <main className="flex-1 overflow-y-auto p-6 md:p-8" data-id="element-44">
          <div className="max-w-6xl mx-auto" data-id="element-45">
            <Outlet data-id="element-46" />
          </div>
        </main>
      </div>
    </div>;
}